var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.searchData.id ? _vm.$t("modify") : _vm.$t("add"),
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.resetForm("ruleForm")
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "popover",
          attrs: {
            "label-position": "left",
            rules: _vm.rules,
            model: _vm.searchData,
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "sensitive_word", label: _vm.$t("sensitiveWord") }
            },
            [
              _c("el-input", {
                staticClass: "operationFrame-entity",
                attrs: { placeholder: _vm.$t("pleaseInputSensitiveWord") },
                model: {
                  value: _vm.searchData.sensitive_word,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "sensitive_word", $$v)
                  },
                  expression: "searchData.sensitive_word"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  return _vm.resetForm()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.clearData(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("reset")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }